import { render, staticRenderFns } from "./classlist.vue?vue&type=template&id=16172a8b&scoped=true&"
import script from "./classlist.vue?vue&type=script&lang=js&"
export * from "./classlist.vue?vue&type=script&lang=js&"
import style0 from "./classlist.vue?vue&type=style&index=0&id=16172a8b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16172a8b",
  null
  
)

export default component.exports